define("MobileFacetButtons.View", [
  "sdb_mobile_facet_buttons_template.tpl",
  "Backbone",
  "Utils",
], function (sdb_mobile_facet_buttons_template_tpl, Backbone, Utils) {
  "use strict";

  return Backbone.View.extend({
    template: sdb_mobile_facet_buttons_template_tpl,
    initialize: function initialize(options) {
      this.isMobile = !!(Utils.getDeviceType() === "phone");
      if (!this.isMobile) return;
      this.plp = options.container.getComponent("PLP");

      this.render = _.wrap(this.render, function (fn) {
        setTimeout(function () {
          var facetsButton = $('[data-target="product-search-facets"]');
          if (facetsButton && facetsButton.length)
            facetsButton[0].addEventListener("click", function () {
              setTimeout(function () {
                var facetsElement = $(".facets-facet-browse-facets");
                if (
                  facetsElement &&
                  facetsElement.length &&
                  facetsElement[0].getAttribute("data-action") === "sc-pushing"
                )
                  facetsElement[0].scrollTo(0, 0);
              }, 0);
            });
        }, 0);
        return fn.apply(this, Array.prototype.slice.call(arguments, 1));
      });
    },
    events: {
      "click #submit-filters": "sumbitFilters",
      "click #clear-filters": "clearFilters",
    },

    sumbitFilters: function sumbitFilters(e) {
      var backButton = $('[data-action="sc-pusher-dismiss"]');
      if (!backButton || !backButton.length) return;
      backButton.click();
    },

    clearFilters: function clearFilters(e) {
      if (!this.plp) return;
      this.plp.setFilters({ filters: {} });
    },

    bindings: {},
    childViews: {},
    getContext: function getContext() {
      return {
        isMobile: this.isMobile,
      };
    },
  });
});
